import React, { useEffect, useState } from 'react';
import { LinkIcon } from '@heroicons/react/24/outline';
import DialogShell from './dialog-shell';
import {
  FieldLabel,
  FieldError,
  primaryButtonClass,
  secondaryButtonClass,
} from './settings-ui';
import { toSlug, SLUG_MAX_LENGTH } from '../../../../utils/slug';

export default function StoreSlugUpsertModal({
  show,
  onClose,
  loading,
  errors,
  storeDetail,
  onSubmit,
}) {
  const [slug, setSlug] = useState(storeDetail.slug || '');

  useEffect(() => {
    if (show) {
      setSlug(storeDetail.slug || '');
    }
  }, [show, storeDetail.slug]);

  const orderHost = (process.env.REACT_APP_ORDER_URL || '').replace(
    /^https?:\/\//,
    '',
  );

  return (
    <DialogShell
      show={show}
      onClose={onClose}
      title="Create order link"
      description="Claim a short URL customers can visit to place orders directly with this store."
      size="md"
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className={secondaryButtonClass}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onSubmit(slug)}
            disabled={loading}
            className={primaryButtonClass}
          >
            <LinkIcon className="h-4 w-4" aria-hidden="true" />
            {loading ? 'Saving…' : 'Create order link'}
          </button>
        </>
      }
    >
      <div className="space-y-2">
        <FieldLabel htmlFor="slug" required>
          Site slug
        </FieldLabel>
        <div className="flex overflow-hidden rounded-md border border-slate-200 shadow-sm focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-500/30 dark:border-slate-600 dark:focus-within:border-sky-400 dark:focus-within:ring-sky-400/30">
          <span className="inline-flex items-center bg-slate-50 px-3 text-sm text-slate-500 dark:bg-slate-800 dark:text-slate-400">
            {orderHost}/
          </span>
          <input
            id="slug"
            type="text"
            value={slug}
            maxLength={SLUG_MAX_LENGTH}
            onChange={(e) => setSlug(toSlug(e.target.value))}
            placeholder="mystorename"
            className="block w-full border-0 bg-white px-3 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-0 dark:bg-slate-900 dark:text-slate-100 dark:placeholder:text-slate-500"
          />
        </div>
        <FieldError
          message={errors?.slug ? 'Please enter a store slug.' : null}
        />
        <p className="text-[11px] text-slate-400 dark:text-slate-500">
          Lowercase letters, numbers, and hyphens only. Up to 30 characters.
        </p>
      </div>
    </DialogShell>
  );
}
